<!--
  ~ Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<div
  *ngFor="let loader of elementArray(); let i = index"
  [bciLoadingTextSkeleton]="i % 2 ? false : true"
  class="list-skeleton"
></div>
